import { createSelector } from 'reselect';
import getSpacesListOrder from './getSpacesListOrder';
import { ORDER_VARIANTS, ORDER_LABELS } from '../constants';

const getVariants = () => ORDER_VARIANTS;

const getOrderVariants = createSelector(
	getVariants,
	getSpacesListOrder,
	(vars, curr) => {
		return Object.keys(vars)
			.map((variant) => {
				return {
					id: vars[variant],
					label: ORDER_LABELS[vars[variant]],
				};
			})
			.filter((i) => i.id !== curr);
	},
);

export default getOrderVariants;
